import { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { getVideo } from '../../../../s3Func/s3Download';
import MediaService from '../../../../services/MediaService';

import AudioSlider from './AudioSlider';

import './SingingRecordReview.scss';

const SingingRecordPreview = ({
  recordUrl,
  audio,
  onConfirmRecord,
  onCancelRecord,
}) => {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [audioSrc, setAudioSrc] = useState(null);

  const confirmIcon = MediaService.getImage(
    '/Module1Images/check_button_small.png',
    login
  );

  const cancelIcon = MediaService.getImage(
    '/Module1Images/x_button.png',
    login
  );

  useEffect(() => {
    const getData = async () => {
      const audioData = await getVideo(audio, login);
      setAudioSrc(audioData);
    };

    getData();
  });

  return (
    <>
      <div className='recording-page'>
        <AudioSlider audioSrc={audioSrc} recordingSrc={recordUrl}></AudioSlider>

        <div className='review-actions'>
          <button onClick={onCancelRecord}>
            <img src={cancelIcon} alt='cancel button' />
          </button>
          <button onClick={onConfirmRecord}>
            <img src={confirmIcon} alt='confirm button' />
          </button>
        </div>
      </div>
    </>
  );
};

export default SingingRecordPreview;
